module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/sales-orders/sales-orders.component.html
// module id = ./src/app/Pages/sales-orders/sales-orders.component.html
// module chunks = main